"use client"

import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import { resultPostprocessing2 } from "@/components/fetcher/fetchInterceptor"
import {
  IOSShelfAnalyzeRequest,
  AOSShelfAnalyzeRequest,
} from "@/app/api/shelf/shelf-analyze/analyze/_type/ShelfAnalyzeEntity"

const ROOT = process.env.NEXT_PUBLIC_ROOT

export interface AnalyzeRequest {
  text: IOSShelfAnalyzeRequest | AOSShelfAnalyzeRequest
  osType: "ios" | "android"
  appVersion?: { version: string; osType: "android" | "ios" } | null
}

export interface AnalyzeResponse {
  id: string
  userId: string
  requestText: string
  responseText: string | null
  status: "PROCESSING" | "COMPLETED" | "FAILED"
  isPolling: boolean
  createdAt: string
  updatedAt: string | null
}

const fetchClientBookShelfAnalyze = (params: AnalyzeRequest) => {
  // appVersion이 있으면 appVersion.osType 사용, 없으면 기존 params.osType 사용
  const effectiveOsType = params.appVersion?.osType ?? params.osType
  const apiEndpoint =
    effectiveOsType === "ios"
      ? "/api/shelf/shelf-analyze/analyze/ios"
      : "/api/shelf/shelf-analyze/analyze/aos"

  return fetchInterceptorInClient(
    {
      method: "post",
    },
    ROOT,
  )(() => apiEndpoint, {
    text: params.text,
  }).then(resultPostprocessing2<AnalyzeResponse>)
}

export default fetchClientBookShelfAnalyze
